import React, { Component } from 'react';
import './ChildStatusAnnouncement.css';
import {Label,Button } from 'react-bootstrap';
import {FormattedDate} from 'react-intl';
import MonitorApi from '../../utils/MonitorApi';

var AnnouncementActions  = require('../../actions/AnnouncementActions');
var Translate   = require('react-translate-component');
var issueStates = {investigating:{panelColor:'warning'},monitoring:{panelColor:'info'},resolved:{panelColor:'success'}};

export default class ChildStatusAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.isAuthorized = MonitorApi.isAuthorized();
    if(props.announcement !== undefined){
      props.announcement.id ? this.state={announcement:props.announcement,editMode: false} : this.state={announcement:props.announcement,editMode: true};
    }
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleIssueStateChange = this.handleIssueStateChange.bind(this);
    this.saveAnnouncement = this.saveAnnouncement.bind(this);
    this.deleteAnnouncement = this.deleteAnnouncement.bind(this);
    this.editModeAnnouncement = this.editModeAnnouncement.bind(this);
  }

  saveAnnouncement(){
    if(this.state.announcement.id){
      AnnouncementActions.editAnnouncement(this.state.announcement);
    } else {
      AnnouncementActions.addAnnouncement(this.state.announcement);
    }
    this.editModeAnnouncement();
  }

  editModeAnnouncement(){
    this.setState({editMode:!this.state.editMode});
  }

  deleteAnnouncement(){
    AnnouncementActions.deleteAnnouncement(this.state.announcement);
  }

  handleMessageChange(newTitle){
    var tempAnnouncement = this.state.announcement;
    tempAnnouncement.message = newTitle.target.value;
    this.setState({announcement: tempAnnouncement});
  }
  handleIssueStateChange(issueState){
    var tempAnnouncement = this.state.announcement;
    if(issueState.target.value === ''){
      delete tempAnnouncement.issueState;
    } else {
      tempAnnouncement.issueState = issueState.target.value;

    }
    this.setState({announcement: tempAnnouncement});
  }

  renderEditIssueState(){
    var serviceVisual = [];
    Object.keys(issueStates).forEach(function (key) {
      serviceVisual.push(<option key={key} value={key}>{key}</option>);
    });
    return serviceVisual;
  }

  render() {
    return (
      <div className="max_width marginToTop">
        {
          this.isAuthorized && this.state.editMode && this.state.announcement ?
            <div>
              {
                this.isAuthorized ?
                  <div className="max_width">
                    {
                      this.state.announcement.id ?
                        <Button onClick={this.deleteAnnouncement}
                                className='centerAll no_style delete_button'><span className="icon_button icon-trash-2"></span></Button>
                        :undefined
                    }
                    <Button onClick={this.editModeAnnouncement}
                            className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                    </Button>
                  </div> : undefined
              }
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.message' />
                </div>
                <div className='col-xs-8'>
                  <input type='text'
                         value={this.state.announcement.message || ''}
                         className='form-control'
                         onChange={this.handleMessageChange} />
                </div>
              </div>
              <div className='col-xs-12 row-flex row-flex-wrap edit_block marginToTop'>
                <div className='col-xs-4 verticalCenter'>
                  <Translate component='p' className='noMargin' content='watchdog.statushistory.announcement.state' />
                </div>
                <div className='col-xs-8'>
                  <select className="form-control" value={this.state.announcement.issueState} onChange={this.handleIssueStateChange} ref="valid_for">
                    <option value={undefined}> </option>
                    {this.renderEditIssueState()}
                  </select>
                </div>
              </div>
              <div className="col-xs-12 marginToTop">
                <Button onClick={this.saveAnnouncement}
                        className='no_style save_button col-xs-3 col-xs-offset-5'> <Translate component='span' content={'watchdog.entitySave'} />
                </Button>
              </div>
            </div>
            :
            <div>
              { this.state.announcement ?
                <div>
                {
                  this.isAuthorized ?
                  <div className="max_width">
                    {
                      this.state.announcement.id ?
                        <Button onClick={this.deleteAnnouncement}
                                className='centerAll no_style delete_button'><span className="icon_button icon-trash-2"></span></Button>
                        :undefined
                    }
                    <Button onClick={this.editModeAnnouncement}
                            className='centerAll no_style edit_button'><span className="icon_button icon-edit-2"></span>
                    </Button>
                  </div> : undefined
              }
                  <div className="maxWidth">
                    { this.state.announcement.issueState ?
                      <Label key={this.state.announcement.issueState} bsStyle={issueStates[this.state.announcement.issueState].panelColor}>{this.state.announcement.issueState}</Label>
                      :undefined
                    }
                    <p className="noMargin float_margin_left"><b>
                    <FormattedDate
                    value={this.state.announcement.date}
                    day="numeric"
                    month="long"
                    year="numeric" />
                    </b></p>
                    <p className="noMargin float_margin_left" >{new Date(this.state.announcement.date).toLocaleTimeString()}</p>
                  </div>
                  <p className="announcement_context announcement_child_message max_width">
                  {this.state.announcement.message}
                  </p>
                    </div>:undefined}

            </div>
        }
      </div>
    );
  }

  componentDidMount() {
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/ChildStatusAnnouncement/ChildStatusAnnouncement.jsx
 **/